<ng-template cdkPortal #shopperNotes="cdkPortal">
	<cdx-modal [center]="true" padding="medium" (closeEmitter)="closeShopperNoteModal()">
		<product-shopper-notes
			[isModal]="true"
			[productName]="product?.name"
			[productImageSrc]="product?.images?.big"
			[sku]="product?.sku"
		>
		</product-shopper-notes>
	</cdx-modal>
</ng-template>
<div
	*ngIf="visible && product?.productTag && shouldTagShowAsStrap && !hideTagsForItemWithChangedPrice"
	class="row-fluid"
	role="row"
>
	<div class="product-strapContainer" role="cell">
		<product-tag
			[tag]="product?.productTag"
			[price]="product?.price"
			[uniqueId]="uniqueid"
			[asStrap]="true"
		></product-tag>
	</div>
	<!-- Empty table cells to retain the product-total styling in the 10-11 columns. -->
	<div class="product-tagStrapDesktopOnly span4" role="cell"></div>
	<div class="product-tagStrapDesktopOnly span2 product-total" role="cell"></div>
</div>
<div *ngIf="product && visible" class="row-fluid product-container" role="row">
	<div class="product-details span5" role="cell">
		<div class="product-imageAndTag">
			<product-tag
				*ngIf="product?.productTag && !shouldTagShowAsStrap && !hideTagsForItemWithChangedPrice"
				[tag]="product?.productTag"
				[uniqueId]="uniqueid"
				[price]="product?.price"
				[targetedOfferCropped]="false"
				[showTargetedOfferText]="false"
				[fixedSize]="true"
			></product-tag>
			<product-fuel-tag
				*ngIf="product?.productTag && !hideTagsForItemWithChangedPrice"
				[tag]="product?.productTag"
			></product-fuel-tag>
			<a
				routerLink="/shop/productdetails"
				[queryParams]="{ stockcode: product?.sku, name: nameInKebabCase }"
				[attr.aria-labelledby]="ariaLabelIds"
				(click)="onClick(position)"
			>
				<figure
					cdxProductImage
					[lazyLoad]="true"
					[images]="product?.images"
					[name]="product?.name"
					size="extra-small"
					labelledBy="product-{{ uniqueid }}-title"
				></figure>
			</a>
		</div>

		<div class="product-titleAndPrice">
			<cdx-badge *ngIf="!productIsInStock" class="badgeOutOfStock highlight" badgeText="Out of stock"></cdx-badge>
			<a
				routerLink="/shop/productdetails"
				[queryParams]="{ stockcode: product?.sku, name: nameInKebabCase }"
				[attr.aria-labelledby]="ariaLabelIds"
				(click)="onClick(position)"
			>
				<h2
					class="heading--5"
					i18n="@@product-productTitle"
					id="product-{{ uniqueid }}-title"
					[attr.aria-label]="product?.name | capitalizeSpecificWords | srPunctuation"
				>
					{{ productTitle | capitalizeSpecificWords }}
				</h2>
				<product-price-meta
					[size]="product?.size"
					[uniqueId]="uniqueid"
					[cupPrice]="cupPrice"
					[supportsEachAndKgPricing]="product?.supportsBothEachAndKgPricing"
				></product-price-meta>
			</a>
			<ng-container *ngIf="productIsInStock">
				<product-price-single-unit-average
					[singleUnitPrice]="product?.price?.averagePricePerSingleUnit"
					[uniqueId]="uniqueid"
					[supportsEachAndKgPricing]="product?.supportsBothEachAndKgPricing"
					[departmentName]="productDepartmentName"
					[packageType]="product?.size?.packageType"
				></product-price-single-unit-average>
				<product-price
					[layout]="layout.list"
					[price]="product?.price"
					[uniqueId]="uniqueid"
					[unit]="product?.unit"
					[supportsEachAndKgPricing]="product?.supportsBothEachAndKgPricing"
					[selectedPurchasingUnit]="product?.selectedPurchasingUnit"
					[isProductTagClubPrice]="isProductTagClubPrice"
				></product-price>
				<a
					class="product-notes hidden-phone"
					[attr.aria-label]="shopperNoteLabel"
					routerLink="."
					(click)="shopperNoteClick()"
					attr.data-cy="productNotes-{{ product.sku }}"
				>
					<cdx-svg-icon [name]="shopperNotesIcon" fill="green" start></cdx-svg-icon>
					<span>{{ hasShopperNotes ? shopperNoteFromState : shopperNoteLabelAdd }}</span>
				</a>
			</ng-container>
			<div *ngIf="!productIsInStock" class="hidden-phone btnContainerForUnavailableItem">
				<button
					attr.data-cy="findAlternativeInTrolley-{{ product.sku }}"
					cdxButton
					class="findAlternativeInTrolleyBtn"
					fillStyle="primary"
					(click)="handleFindAlternative()"
					i18n="@@revieTrolley-findAlternative"
					attr.aria-label="Find alternative button"
				>
					Find alternative
				</button>

				<button
					attr.data-cy="removeTrolleyBtn-{{ product.sku }}"
					cdxButton
					class="removeTrolleyBtn"
					fillStyle="outline"
					(click)="removeItemFromTrolley(sourceCarousel, pageSource, target, true)"
					attr.aria-label="Remove item button"
				>
					Remove item
				</button>
			</div>
		</div>
	</div>

	<div class="product-total--mobile visible-phone" *ngIf="productIsInStock">
		<p>
			Item total <strong>{{ itemTotal }}</strong>
		</p>
	</div>

	<div *ngIf="productIsInStock" class="product-controls span2" role="cell">
		<ng-container
			*ngIf="
				showChangedPriceTutorial && isMobileDevice === false && enabledChangedPriceTutorial === true;
				then renderPopupContent;
				else noPopup
			"
		></ng-container>
		<ng-template #renderPopupContent>
			<cdx-popup
				popupActiveClass="popupOpen"
				customClass="changePriceTutorial"
				hasBackdrop="true"
				[popupId]="'priceChangePopupStepOne'"
				[shouldListenToClickAway]="false"
				[hasCloseBtn]="true"
				id="priceChangePopupStepOne"
			>
				<product-add-to-trolley
					cdxPopupTarget
					[ignoreClickEvent]="true"
					[id]="uniqueid"
					[title]="product?.name"
					[unit]="pricingUnit"
					[layout]="layout.list"
					[shopper]="isShopper"
					(addToTrolleyEmitter)="addToTrolleyClick(pageSource, target, sourceCarousel, true)"
					(updateQuantityEmitter)="updateQuantity($event, pageSource, target, sourceCarousel, true)"
					(changeEmitter)="addToTrolleyClick(pageSource, target, sourceCarousel)"
				></product-add-to-trolley>
				<ng-container cardContent>
					<h5>Pricing changes</h5>
					<p>If you edit the quantity or weight of existing items, they'll change to today's pricing.</p>
					<div class="popupButtons">
						<span>1/2</span>
						<button
							cdxButton
							fillStyle="link"
							i18n="@@tutorialPopupStepOne-nextBtn"
							(click)="handlePriceChangeTutorialNext()"
						>
							Next
						</button>
					</div>
				</ng-container>
			</cdx-popup>
		</ng-template>
		<ng-template #noPopup>
			<product-add-to-trolley
				[id]="uniqueid"
				[title]="product?.name"
				[unit]="pricingUnit"
				[layout]="layout.list"
				[shopper]="isShopper"
				(addToTrolleyEmitter)="addToTrolleyClick(pageSource, target, sourceCarousel, true)"
				(updateQuantityEmitter)="updateQuantity($event, pageSource, target, sourceCarousel, true)"
				(changeEmitter)="addToTrolleyClick(pageSource, target, sourceCarousel)"
			></product-add-to-trolley>
		</ng-template>
		<button
			attr.data-cy="removeTrolleyBtn-{{ product.sku }}"
			fillStyle="tertiaryFlat"
			startSlotSize="extra-small"
			size="small"
			[startSlotActive]="true"
			(click)="removeItemFromTrolley(sourceCarousel, pageSource, target, true)"
			cdxButton
		>
			<cdx-svg-icon name="cross" size="extra-small" fill="dark" start></cdx-svg-icon>
			Remove
		</button>
	</div>

	<div class="product-savings span2 hidden-phone" *ngIf="productIsInStock" role="cell">
		<p attr.data-cy="product-savings-{{ product.sku }}"><span class="sr-only">Savings:</span>{{ savingsTotal }}</p>
	</div>

	<div class="product-total span2 hidden-phone" *ngIf="productIsInStock" role="cell">
		<p>
			<span class="sr-only">Item total:</span><strong>{{ itemTotal }}</strong>
		</p>
	</div>

	<cdx-alert
		*ngIf="showTargetedOfferNotification"
		type="info"
		[animate]="false"
		class="visible-phone product-offer-details--mobile"
		title="Offer limit {{
			product.productTag?.targetedOffer?.maxRedemptionCount
		}}. Additional products charged in full"
		attr.data-cy="maxredemptioncountinfo-{{ product.sku }}"
		[fullwidth]="true"
	>
	</cdx-alert>

	<div class="product-footer--mobile visible-phone">
		<button
			cdxButton
			*ngIf="productIsInStock"
			class="product-notes"
			fillStyle="secondaryFlat"
			[inline]="true"
			size="small"
			[startSlotActive]="true"
			[attr.aria-label]="shopperNoteLabel"
			attr.data-cy="productNotes-{{ product.sku }}"
			(click)="shopperNoteClick()"
		>
			<cdx-svg-icon [name]="shopperNotesIcon" fill="green" start></cdx-svg-icon>
			<span>{{ hasShopperNotes ? shopperNoteFromState : shopperNoteLabelAdd }}</span>
		</button>
		<product-allow-subs
			*ngIf="productIsInStock"
			id="product-{{ product.sku }}-subsAllowed--mobile"
			[subsAllowed]="product.subsAllowed"
			(changeEmitter)="handleChangeAllowSubstitutes($event)"
			><span label>Allow subs.</span></product-allow-subs
		>

		<div *ngIf="!productIsInStock" class="visible-phone btnContainerForUnavailableItem">
			<button
				attr.data-cy="findAlternativeInTrolley-{{ product.sku }}"
				cdxButton
				class="findAlternativeInTrolleyBtn"
				fillStyle="primary"
				(click)="handleFindAlternative()"
				i18n="@@revieTrolley-findAlternative"
				attr.aria-label="Find alternative button"
			>
				Find alternative
			</button>

			<button
				attr.data-cy="removeTrolleyBtn-{{ product.sku }}"
				cdxButton
				class="removeTrolleyBtn"
				fillStyle="outline"
				(click)="removeItemFromTrolley(sourceCarousel, pageSource, target, true)"
				attr.aria-label="Remove item button"
			>
				Remove item
			</button>
		</div>
	</div>
	<div class="span1 hidden-phone product-actions" *ngIf="productIsInStock">
		<product-allow-subs
			data-cy="prodctAllowSubs"
			id="product-{{ product.sku }}-subsAllowed"
			[subsAllowed]="product?.subsAllowed"
			(changeEmitter)="handleChangeAllowSubstitutes($event)"
		></product-allow-subs>
	</div>
</div>
